import { render } from "./MobileStopperScreen.vue?vue&type=template&id=55065b22"
import script from "./MobileStopperScreen.vue?vue&type=script&lang=js"
export * from "./MobileStopperScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__